import { useCallback } from "react";

import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { CustomAITaskFormItemKeys } from "../constants";
import { CustomAITaskLexInput } from "./Components/CustomAITaskLexInput/CustomAITaskLexInput";

import sharedStyles from "../SharedDemoStyles.module.scss";

const REQUIRED_RULE = generateFormItemRequiredRules("Custom AI Task");
const NAME_LABEL = "Name of Custom AI Task";
const INPUT_LABEL = "Input";
const PROMPT_LABEL = "Prompt";

export function CustomAITaskFormItems(): JSX.Element {
    const inputChange = useCallback(() => {}, []);

    return (
        <>
            <RVFormFloatingLabelWrap
                className={sharedStyles.singleItem}
                showFormLabel
                name={CustomAITaskFormItemKeys.customAITaskName}
                label={NAME_LABEL}
                rules={REQUIRED_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>

            <CustomAITaskLexInput
                formClassName={sharedStyles.singleItem}
                label={INPUT_LABEL}
                isSingleLine={true}
                name={CustomAITaskFormItemKeys.customAITaskInput}
                onChange={inputChange}
            />

            <CustomAITaskLexInput
                formClassName={sharedStyles.singleItem}
                label={PROMPT_LABEL}
                isSingleLine={false}
                name={CustomAITaskFormItemKeys.customAITaskPrompt}
                onChange={inputChange}
            />
        </>
    );
}
